import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  Role,
  RoutePath,
  SystemMessage,
  USER_INFO_KEY,
} from "@app/constants";
import AuthService from "@app/services/http/auth.service";
import { storeUser } from "@app/store/auth";
import { LoginRequest, UserData } from "@app/types";
import { loginValidationSchema } from "@app/validations";
import { Images } from "@assets/images";
import StorageService from "@core/services/storage";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

function SignIn() {
  const formRef = createRef<FormikContextType<LoginRequest>>();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (values: LoginRequest) => {
    AuthService.login(values.email, values.password).then((res) => {
      const { accessToken, refreshToken, user, isMfaEnable, verifyMethods } =
        res.data;

      if (
        user.role !== Role.ADMIN &&
        user.role !== Role.ROOT &&
        user.role !== Role.ADMIN_ROOT
      ) {
        addToast({ text: SystemMessage.ACCESS_DENIED, status: "inValid" });

        return;
      }

      if (verifyMethods?.length) {
        StorageService.setSession(ACCESS_TOKEN_KEY, accessToken);

        navigate(`/${RoutePath.OTP}?method=${verifyMethods[0]}`);

        return;
      }

      if (isMfaEnable) {
        StorageService.setSession(ACCESS_TOKEN_KEY, accessToken);
        navigate(`/${RoutePath.OTP}`);

        return;
      }

      const userData: UserData = {
        id: user.id,
        username: user.username,
        email: user.email,
        role: user.role,
        fullName: user.fullName,
        thumbnail: user.thumbnail,
      };

      StorageService.set(ACCESS_TOKEN_KEY, accessToken);
      StorageService.set(REFRESH_TOKEN_KEY, refreshToken);
      StorageService.setObject(USER_INFO_KEY, userData);
      dispatch(storeUser(user));
      navigate(`/${RoutePath.STATISTICS}`);
    });
  };

  return (
    <div className="bg-color w-screen h-screen flex items-center justify-center">
      <div className="w-[443px] h-auto px-[34px] py-11 bg-white rounded-xl">
        <div className="flex justify-center">
          <img className="w-28" src={Images.LogoText.default} alt="" />
        </div>
        <div className="mt-6 font-semibold text-xl text-center neutral-n80 font-[SVN-Gilroy]">
          Chào mừng trở lại!
        </div>
        <div className="mt-2 black-30 text-sm text-center black-30 font-[SVN-Gilroy] font-medium">
          Đăng nhập vào tài khoản của bạn
        </div>
        <Formik
          innerRef={formRef}
          initialValues={{ email: "", password: "" }}
          onSubmit={onSubmit}
          validationSchema={loginValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="mt-[60px]">
              <FormControl name="email">
                <Input
                  inputIcon={Images.MessageIcon.default}
                  inputIconClassName="!w-[18px] !h-[18px]"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>
            <div className="mt-3">
              <FormControl name="password">
                <Input
                  type="password"
                  inputIcon={Images.SecurityIcon.default}
                  inputIconClassName="!w-[18px] !h-[18px]"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>
            <Button
              type="submit"
              containerClassName="mt-12 mx-auto"
              label="Đăng nhập"
              labelClassName="font-[SVN-Gilroy]"
              width="fit-content"
              size="l"
              className="text-lg font-bold px-11"
            />
          </Form>
        </Formik>
      </div>
    </div>
  );
}

export default SignIn;
